module.exports = __webpack_public_path__ + "static/img/braided-material.26a7783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/braided-material.png
// module id = zoeP
// module chunks = 2